import { createSchemaConfig, buildTimeIntervalDimensionsConfig } from '../helpers/schema.helpers'
import { InsightsFormatterType, InsightsMetricDesiredDirection } from '../types/schema.types'
import { Metrics, Dimensions } from './insightsPortalAggWarehousePerformance.types'

export { Metrics, Dimensions }

export const schemaConfig = createSchemaConfig({
  metrics: Metrics,
  dimensions: Dimensions,
  metricsConfig: {
    [Metrics.SUM_GMV]: {
      formatter: InsightsFormatterType.Currency,
      label: 'insightsPortalDomain.performanceDashboard.metrics.SUM_GMV',
      tooltip: 'insightsPortalDomain.performanceDashboard.tooltips.SUM_GMV',
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
    },
    [Metrics.COUNT_ORDER]: {
      formatter: InsightsFormatterType.Integer,
      label: 'insightsPortalDomain.performanceDashboard.metrics.COUNT_ORDER',
      tooltip: 'insightsPortalDomain.performanceDashboard.tooltips.COUNT_ORDER',
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
    },
    [Metrics.COUNT_FIRST_ORDER]: {
      formatter: InsightsFormatterType.Integer,
      label: 'insightsPortalDomain.performanceDashboard.metrics.COUNT_FIRST_ORDER',
      tooltip: 'insightsPortalDomain.performanceDashboard.tooltips.COUNT_FIRST_ORDER',
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
    },
    [Metrics.AVG_BASKET]: {
      formatter: InsightsFormatterType.Currency,
      label: 'insightsPortalDomain.performanceDashboard.metrics.AVG_GMV',
      tooltip: 'insightsPortalDomain.performanceDashboard.tooltips.AVG_GMV',
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
    },
    [Metrics.AVG_RATING]: {
      formatter: InsightsFormatterType.Decimal,
      label: 'insightsPortalDomain.performanceDashboard.metrics.AVG_RATING',
      tooltip: 'insightsPortalDomain.performanceDashboard.tooltips.AVG_RATING',
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
    },
    [Metrics.AVG_ORDERED_ITEM]: {
      formatter: InsightsFormatterType.Integer,
      label: 'insightsPortalDomain.basketDashboard.metrics.AVG_ORDERED_ITEM',
      tooltip: 'insightsPortalDomain.basketDashboard.tooltips.AVG_ORDERED_ITEM',
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
    },
    [Metrics.AVG_ITEM_FOUND]: {
      formatter: InsightsFormatterType.Percentage,
      label: 'insightsPortalDomain.orderItems.metrics.AVG_ITEM_FOUND',
      tooltip: 'insightsPortalDomain.outOfStockDashboard.tooltips.AVG_ITEM_FOUND',
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
    },
    [Metrics.AVG_ITEM_FILLED]: {
      formatter: InsightsFormatterType.Percentage,
      label: 'insightsPortalDomain.outOfStockDashboard.metrics.AVG_ITEM_FILLED',
      tooltip: 'insightsPortalDomain.outOfStockDashboard.tooltips.AVG_ITEM_FILLED',
      desiredDirection: InsightsMetricDesiredDirection.POSITIVE,
    },
    [Metrics.RATIO_UNATA_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_CONNECT_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_MARKETPLACE_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_PBI_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_LMD_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_DELIVERY_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_EBT_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_CONVENIENCE_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_ALCOHOL_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_EXPRESS_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_LOYALTY_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_FIRST_ORDER_GMV]: {
      formatter: InsightsFormatterType.Percentage,
    },
    [Metrics.RATIO_ORDER_WITH_RATING]: {
      formatter: InsightsFormatterType.Percentage,
    },
  },
  dimensionsConfig: {
    [Dimensions.ORDER_CURRENCY]: {
      label: 'insightsPortalDomain.filters.orderCurrency.label',
    },
    [Dimensions.PARTNER_GEO_DIVISION]: {
      label: 'insightsPortalDomain.filters.partnerDivision.label',
    },
    [Dimensions.REGION]: {
      label: 'insightsPortalDomain.filters.region.label',
    },
    [Dimensions.WAREHOUSE]: {
      label: 'insightsPortalDomain.filters.retailers.label',
    },
    [Dimensions.WAREHOUSE_LOCATION]: {
      label: 'insightsPortalDomain.filters.stores',
    },
    [Dimensions.WAREHOUSE_LOCATION_CODE]: {
      label: 'insightsPortalDomain.filters.storeLocationCode.label',
    },
    [Dimensions.WAREHOUSE_LOCATION_GROUP]: {
      label: 'insightsPortalDomain.filters.storeGroup.label',
    },
    [Dimensions.WAREHOUSE_LOCATION_STATE]: {
      label: 'insightsPortalDomain.filters.state.label',
    },
    [Dimensions.FULFILLMENT_TYPE]: {
      label:
        'insightsPortalDomain.performanceOverview.performanceByProgram.programName.FULFILLMENT_TYPE',
    },
    [Dimensions.INSIGHTS_PORTAL_ORDER_SOURCE]: {
      label: 'insightsPortalDomain.filters.orderSource.label',
    },
    [Dimensions.INSIGHTS_PORTAL_REPORTING_PLATFORM]: {
      label: 'insightsPortalDomain.placements.filters.platform',
    },
    ...buildTimeIntervalDimensionsConfig,
  },
})
